import { useThemeContext } from "#contexts/ThemeContext";
import { makeStyles } from '@material-ui/core';

export const priceBoxShadow = 'rgba(149, 157, 165, 0.2) 0px 8px 24px';

export const useProductStyle = () => {
  const {
    primaryButtonBackground,
    primaryButtonText,
    productHighlightsText,
    priceText,
    productTitle,
    answerHelperText,
    iconButtons,
    questionText,
    bodyColor
  } = useThemeContext();
  return makeStyles({
    button: {
      backgroundColor: primaryButtonBackground,
      color: primaryButtonText,
      '& span': {
        color: `${primaryButtonText}!important`
      },
      '&:hover': {
        backgroundColor: primaryButtonBackground,
        opacity: 0.8
      }
    },
    videoButton: {
      color: primaryButtonBackground,
      border: `1px solid ${primaryButtonBackground}`
    },
    imageCustom: {
      objectFit: 'contain',
      margin: 'auto'
    },
    priceText: {
      color: priceText
    },
    textButton: {
      color: primaryButtonText
    },
    priceRangeText: {
      color: productHighlightsText
    },
    productTitleText: {
      color: productTitle
    },
    helperColor: {
      color: answerHelperText
    },
    iconColor: {
      color: iconButtons
    },
    questionText: {
      color: questionText
    },
    bodyText: {
      color: bodyColor
    }
  })();
};
